<template>
  <Page :id="id" @update:page="page = $event">
    <template v-slot:after-title>
      <div class="input-group mb-3">
        <input
          class="faq-search form-control form-control-lg"
          :placeholder="$t('searchTopic')"
          @input="lazilyUpdateQuery($event.target.value)"
        >
        <div class="input-group-append">
          <span class="input-group-text icon-search d-block" />
        </div>
      </div>
    </template>
    <template v-slot:default>
      <ExpandableList :items="page.questions" :query="searchQuery" />
    </template>
  </Page>
</template>

<script>
import ExpandableList from '../components/ExpandableList';
import Page from './Page';

export default {
  props: ['id'],
  components: {
    Page,
    ExpandableList,
  },
  data: () => ({
    page: {},
    timerId: 0,
    searchQuery: '',
  }),
  methods: {
    lazilyUpdateQuery(text) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => this.searchQuery = text, 200);
    },
  },
};
</script>
